import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const Google: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon viewBox="0 0 24 25" className={className} size={size} disabled={disabled} disableStrokeColor fill="none">
    <path
      id="Vector"
      d="M22.56 12.75C22.56 11.97 22.49 11.22 22.36 10.5H12V14.76H17.92C17.66 16.13 16.88 17.29 15.71 18.07V20.84H19.28C21.36 18.92 22.56 16.1 22.56 12.75Z"
      fill="#4285F4"
    />
    <path
      id="Vector_2"
      d="M12 23.5001C14.97 23.5001 17.46 22.5201 19.28 20.8401L15.71 18.0701C14.73 18.7301 13.48 19.1301 12 19.1301C9.14 19.1301 6.71 17.2001 5.84 14.6001H2.18V17.4401C3.99 21.0301 7.7 23.5001 12 23.5001Z"
      fill="#34A853"
    />
    <path
      id="Vector_3"
      d="M5.84 14.5901C5.62 13.9301 5.49 13.2301 5.49 12.5001C5.49 11.7701 5.62 11.0701 5.84 10.4101V7.57007H2.18C1.43 9.05007 1 10.7201 1 12.5001C1 14.2801 1.43 15.9501 2.18 17.4301L5.03 15.2101L5.84 14.5901Z"
      fill="#FBBC05"
    />
    <path
      id="Vector_4"
      d="M12 5.88C13.62 5.88 15.06 6.44 16.21 7.52L19.36 4.37C17.45 2.59 14.97 1.5 12 1.5C7.7 1.5 3.99 3.97 2.18 7.57L5.84 10.41C6.71 7.81 9.14 5.88 12 5.88Z"
      fill="#EA4335"
    />
  </SvgIcon>
);

export default Google;
